import React from 'react';
import PropTypes from 'prop-types';

function CheckCircleIcon({ className = 'w-4 h-4 text-white' }) {
  return (
    <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' />
    </svg>
  );
}

CheckCircleIcon.propTypes = {
  className: PropTypes.string,
};

export default CheckCircleIcon;
